import { render } from "./TheTruong_PhongHoc.vue?vue&type=template&id=ff32802a"
import script from "./TheTruong_PhongHoc.vue?vue&type=script&lang=js"
export * from "./TheTruong_PhongHoc.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__